export default "__VITE_ASSET__BFtuDiQI__"